import { ChevronRightIcon } from "@heroicons/react/solid";
import { abbreviateNumberByMagnitude } from "@lib/utils";
import { Gauge } from "@ui/elements";
import useActiveOrg from "@ui/hooks/active-org";
import useActiveSubscription from "@ui/hooks/active-subscription";
import { AlertTriangle, GaugeIcon } from "lucide-react";
import Link from "next/link";
import { useMessagesMetrics } from "@/api/metric";

export function UsageGauge() {
  const { org } = useActiveOrg();
  const { subscription } = useActiveSubscription();
  const { data: metrics } = useMessagesMetrics({
    org: org?.id,
    interval: "all",
    startDate: subscription?.currentInvoiceDate,
    endDate: subscription?.nextInvoiceDate,
  });
  const total = metrics?.[0]?.total?.segments ?? 0;
  const quota = subscription?.configuration?.segmentLimit ?? 0;
  const progress = total / quota;
  const hasQuota = !!subscription?.configuration?.segmentLimit;

  if (subscription === null) {
    return (
      <div className="px-4 pr-2 py-3 border rounded border-border bg-background">
        <Link href={"/settings/billing"} className="flex items-center justify-between">
          <span className="flex items-center">
            <AlertTriangle className="w-5 h-5 shrink-0" />
            <span className="block ml-2">
              <span className="block text-xs leading-tight">No active subscription</span>
              <span className="block text-xs leading-none text-muted-foreground">
                Choose a plan
              </span>
            </span>
          </span>
          <ChevronRightIcon className="w-4 h-4 text-muted-foreground" />
        </Link>
      </div>
    );
  }
  return (
    <div className="px-4 pr-2 py-3 border rounded border-border bg-background">
      <Link href={"/settings/usage"} className="flex items-center justify-between">
        <span className="flex items-center">
          {hasQuota ? (
            <Gauge progress={progress} />
          ) : (
            <GaugeIcon className="text-muted-foreground w-5 h-5 shrink-0 mr-2" />
          )}
          <span className="block ml-2">
            <span className="block text-xs leading-tight">Usage this period</span>
            <span className="block text-xs leading-none text-muted-foreground">
              {abbreviateNumberByMagnitude(total, { fixed: 2 })}
              {hasQuota ? ` of ${abbreviateNumberByMagnitude(quota)} ` : ""} credits used
            </span>
          </span>
        </span>
        <ChevronRightIcon className="w-4 h-4 text-muted-foreground" />
      </Link>
    </div>
  );
}
